// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".resume-dialog--container .resume-inner--container.verify[data-v-11d41b3e]{padding:.533333rem .426667rem;background:#fff;height:auto;border-radius:.266667rem .266667rem 0 0}.resume-dialog--container .resume-inner--container.verify .resume-title[data-v-11d41b3e]{font-size:.48rem;margin-bottom:.266667rem}", ""]);
// Exports
module.exports = exports;
